// account
import account from './account/account';
import approve from './account/approve';
import permission from './account/permission';
import role from './account/role';
// system
import config from './system/config';
import department from './system/department';
import departmentHeader from './system/DepartmentHeader';
import param from './system/param';
import mobileVersion from './system/MobileVersion';
import operatorLog from './system/OperatorLog';
import sysFeedback from './system/SysFeedback';
import sysAbout from './system/SysAbout';
// quartz
import quartzJob from './quartz/QuartzJob';
// gis
import region from './gis/region';
// black
import blacklist from './blacklist/BlackList';
// xbw
import xbw from './xbw/xbw';

// 导出一个map
export default {
  // system module
  account,
  approve,
  config,
  department,
  departmentHeader,
  param,
  permission,
  role,
  mobileVersion,
  operatorLog,
  sysFeedback,
  // gis module
  quartzJob,
  region,
  sysAbout,
  // blacklist module
  blacklist,
  // xbw module
  xbw
};
